"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _WarningPlacesEnd = require("./WarningPlacesEnd");
var _default = exports["default"] = _WarningPlacesEnd.WarningPlacesEnd;